import React, { useState, useEffect } from "react";
import { FaX, FaAngleDown } from "react-icons/fa6";
import Button from "../../../../components/button-v1/index";
import CustomInput from "../../../../components/ui/input";
import { Dropdown } from "../../../../components/ui/dropdown";
import toast from "react-hot-toast";
import styles from "./editVideoModal.module.css";

const EditVideoModal = ({ open, onClose, video, onSave, categories }) => {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [category, setCategory] = useState("");
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    if (video) {
      setTitle(video.title || "");
      setDescription(video.description || "");
      setCategory(video.category || "");
    }
  }, [video]);

  if (!open || !video) return null;

  const categoryOptions = categories.filter(cat => cat.value !== "all");

  const selectedCategoryLabel = category 
    ? categoryOptions.find(c => c.value === category)?.label || category 
    : "Select category";

  const handleSave = async () => {
    const trimmedTitle = title.trim();
    const trimmedDescription = description.trim();
    if (trimmedTitle && trimmedDescription && category) {
      setIsSaving(true);
      try {
        await onSave(trimmedTitle, trimmedDescription, category);
      } finally {
        setIsSaving(false);
      }
    }
  };

  const isSaveDisabled = !(title.trim() && description.trim() && category) || isSaving;

  return (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div className={styles.header}>
          <h2 className={styles.title}>Edit Video Details</h2>
          <button className={styles.closeButton} onClick={onClose}>
            <FaX />
          </button>
        </div>

        <div className={styles.body}>
          <div className={styles.field}>
            <label className={styles.label}>Category</label>
            <Dropdown
              options={categoryOptions}
              value={category}
              onChange={setCategory}
              trigger={
                <div className={styles.dropdownTrigger}>
                  <span>{selectedCategoryLabel}</span>
                  <FaAngleDown />
                </div>
              }
            />
          </div>

          <div className={styles.field}>
            <label className={styles.label}>Video Title</label>
            <CustomInput
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
          </div>

          <div className={styles.field}>
            <label className={styles.label}>Description</label>
            <textarea
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              rows={5}
              className={styles.textarea}
            />
          </div>
        </div>

        <div className={styles.footer}>
          <Button className={styles.cancelButton} onClick={onClose}>
            Cancel
          </Button>
          <Button
            className={styles.actionButton}
            onClick={handleSave}
            disabled={isSaveDisabled}
          >
            {isSaving ? "Saving..." : "Save Changes"}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default EditVideoModal;